module.exports = __webpack_public_path__ + "img/anliku.b9b45364.svg";